// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/* src/components/Profile/Profile.css */
.profile-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.profile-content {
  position: relative;
  background: #fff;
  padding: 2%;
  max-width: 600px;
  margin-top: 5%;
  width: 100%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border: 10px solid #00468c;
}

.profile-close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: x-large;
  cursor: pointer;
  color: #00468c;
  transition: color 0.2s;
}

.profile-close:hover {
  color: #ff4d4f;
}

.profile-header {
  display: flex;
  align-items: center;
}

.profile-photo {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  margin: 3% 10%;
  background-color: #f0f0f0;
}

.profile-name {
  display: flex;
  flex-direction: column;
}

.profile-name h3 {
  margin: 1% 0;
}

.profile-name p {
  margin: 1% 0;
}

.profile-details {
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(2, minmax(20%, 1fr));
}

.profile-details p {
  line-height: 1.6;
  color: #555;
  margin-left: 10%;
}

.profile-loading,
.profile-error {
  text-align: center;
  color: #777;
  padding: 2%;
}


.assigned-assets-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 10px;
  margin-left: 10px;
  margin-right: 10px;
}

.assigned-assets-label {
  width: 200px;
  font-weight: bold;
  margin-left:20px;
}

.assigned-assets-values {
  flex: 1 1;
  margin-right:20px;
  margin-top:-15px;
  margin-left:20px;
  text-align: right; /* Aligns the asset values to the right */
}
`, "",{"version":3,"sources":["webpack://./src/components/Profile/Profile.css"],"names":[],"mappings":";;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB,EAAE,yCAAyC;AAC9D","sourcesContent":["\n\n/* src/components/Profile/Profile.css */\n.profile-popup {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.profile-content {\n  position: relative;\n  background: #fff;\n  padding: 2%;\n  max-width: 600px;\n  margin-top: 5%;\n  width: 100%;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  border: 10px solid #00468c;\n}\n\n.profile-close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: x-large;\n  cursor: pointer;\n  color: #00468c;\n  transition: color 0.2s;\n}\n\n.profile-close:hover {\n  color: #ff4d4f;\n}\n\n.profile-header {\n  display: flex;\n  align-items: center;\n}\n\n.profile-photo {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  object-fit: cover;\n  margin: 3% 10%;\n  background-color: #f0f0f0;\n}\n\n.profile-name {\n  display: flex;\n  flex-direction: column;\n}\n\n.profile-name h3 {\n  margin: 1% 0;\n}\n\n.profile-name p {\n  margin: 1% 0;\n}\n\n.profile-details {\n  display: grid;\n  justify-content: center;\n  grid-template-columns: repeat(2, minmax(20%, 1fr));\n}\n\n.profile-details p {\n  line-height: 1.6;\n  color: #555;\n  margin-left: 10%;\n}\n\n.profile-loading,\n.profile-error {\n  text-align: center;\n  color: #777;\n  padding: 2%;\n}\n\n\n.assigned-assets-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-top: 10px;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.assigned-assets-label {\n  width: 200px;\n  font-weight: bold;\n  margin-left:20px;\n}\n\n.assigned-assets-values {\n  flex: 1;\n  margin-right:20px;\n  margin-top:-15px;\n  margin-left:20px;\n  text-align: right; /* Aligns the asset values to the right */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
